/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AreaIdAreaPatch$Params {
  Accept?: string;
  idArea: string;
      body?: {
}
}

export function areaIdAreaPatch(http: HttpClient, rootUrl: string, params: AreaIdAreaPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, areaIdAreaPatch.PATH, 'patch');
  if (params) {
    rb.header('Accept', params.Accept, {});
    rb.path('idArea', params.idArea, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

areaIdAreaPatch.PATH = '/area/{idArea}';
